import React from 'react';
import { translate } from "react-translate";
import Navbar from './navbar/navbar';
import Cover from './cover/cover';
import Block from './block/block';
import Footer from './footer/footer';

import doctor from '../images/doctor.jpg';
import alex from '../images/alex.png';
import mission from '../images/mission.jpg';
import checklist from '../images/checklist.jpg';
import steps from '../images/steps.jpg';

class HomePage extends React.Component {

  render() {
    return (
      <div>
        <Navbar commonProps={this.props.commonProps} />
        <Cover commonProps={this.props.commonProps} />
        <Block image={doctor} imageAlign="left" title={ this.props.t('basic_info_title') } body={ this.props.t('basic_info_body') } fullBody={ this.props.t('basic_info_body_full') } />
        <Block whiteBG={true} image={alex} imageAlign="right" title={ this.props.t('alex_title') } body={ this.props.t('alex_body') } fullBody={ this.props.t('alex_body_full') } />
        <Block image={mission} imageAlign="left" title={ this.props.t('mission_title') } body={ this.props.t('mission_body') } />
        <Block whiteBG={true} image={checklist} imageAlign="right" title={ this.props.t('tasks_title') } body={ this.props.t('tasks_body') } />
        <Block image={steps} imageAlign="left" title={ this.props.t('steps_title') } body={ this.props.t('steps_body') } />
        <Footer />
      </div>
    );
  }

}

export default translate('HomePage')(HomePage);
